<div class="usd-container">

  <!-- Total User Stories Card -->
  <p class="usd-section-title">User Story Details</p>
  <div class="usd-total-card">
    <span class="usd-total-count">{{data?.total_user_stories}}</span>
    <div class="usd-total-divider"></div>
    <div class="usd-total-info">
      <span class="usd-total-label">Total User Stories</span>
      <span class="usd-total-desc">User stories extracted from ALM to create test cases</span>
    </div>
  </div>

  <!-- User Story Coverage -->
  <p class="usd-section-title usd-coverage-title">User story coverage</p>
  <div class="usd-gauge-wrapper">
    <ngx-gauge
      [matTooltip]="gaugeTooltip"
      matTooltipPosition="above"
      [type]="gaugeType"
      [value]="roundedCoverage"
      [label]="gaugeLabel"
      [size]="251"
      [cap]="'round'"
      [foregroundColor]="'#5f2cff'"
      [backgroundColor]="'#E8E8E9'"
      [thick]="30"
      [append]="gaugeAppendText">
    </ngx-gauge>
  </div>

  <!-- Stat Cards -->
  <div class="usd-stats-row">
    <div class="usd-stat-card usd-stat-covered">
      <div class="usd-stat-divider"></div>
      <div class="usd-stat-left">
        <span class="usd-stat-value">{{data?.covered | number:'1.0-0'}}</span>
        <span class="usd-stat-label">Covered</span>
      </div>
      <span class="usd-stat-percent">{{data?.total_coverage | number:'1.0-0'}}%</span>
    </div>
    <div class="usd-stat-card usd-stat-uncovered">
      <div class="usd-stat-divider"></div>
      <div class="usd-stat-left">
        <span class="usd-stat-value">{{data?.uncovered | number:'1.0-0'}}</span>
        <span class="usd-stat-label">Uncovered</span>
      </div>
      <span class="usd-stat-percent">{{(100 - data?.total_coverage) | number:'1.0-0'}}%</span>
    </div>
  </div>

  <!-- Summary Text -->
  <div class="usd-summary-box">
    <ul>
      <li>
        Out of {{data?.total_user_stories}} stories, {{data?.covered}} are tested
        ({{data?.total_coverage | number:'1.0-0'}}% coverage)<ng-container *ngIf="data?.total_coverage > 50"> {{progressText}}</ng-container>
      </li>
      <li>Focus on the remaining {{data?.uncovered}} uncovered stories to ensure full quality.</li>
    </ul>
  </div>

</div>
